<template>
	<div>
		<vs-row class="pb-5" v-if="retailer && retailer.invalid_credentials">
			<vs-col vs-w="12">
				<vs-alert color="danger" title="Verbinding met Bol.com verbroken!" active="true" class="mt-3">
					<b>De ingevulde client id en client secret zijn niet meer geldig.</b>
					Daarom is het voor piqwise niet meer mogelijk gegevens op te halen bij Bol.com.<br>
					Neem via "Ondersteuning" in het menu of de chat functie contact op met onze klantenservice om dit te verhelpen.
				</vs-alert>
			</vs-col>
		</vs-row>
		<div v-if="loading">
		</div>

		<div v-else>
			<vx-card title="Retailer instellingen">
				<template slot="actions">
					<vx-tooltip class="flex" text="Hoe en wat?">
						<font-awesome-icon icon="question-circle" @click="wiki"></font-awesome-icon>
					</vx-tooltip>
				</template>

				<div>
					<div v-if="retailer.client_id !== undefined && retailer.client_secret !== undefined">
						<vs-row>
							<vs-col vs-w="12">
								<h3>Client id:</h3>
							</vs-col>
							<vs-col vs-w="12">
								<label class="input-label">{{ retailer.client_id }}</label>
							</vs-col>
							<vs-col vs-w="12">
								<h3>Client secret:</h3>
							</vs-col>
							<vs-col vs-w="12">
								<label class="input-label">{{ retailer.client_secret }}</label>
							</vs-col>
							<vs-col vs-w="12">
								<h3>Retailer naam:&ensp; </h3>
							</vs-col>
							<vs-col vs-w="4">
								<inline-input :value="this.retailerUpdate.name" @submit="submitChangeName" @cancel="cancelEdit"
											  :validate-rules="retailerNameValidation.rules" :validate-messages="retailerNameValidation.messages"/>
							</vs-col>
						</vs-row>
					</div>

					<div v-else>
						<vs-row>
							<vs-col vs-w="12">
								<vs-input label="client id" v-validate="'required'" name="clientId" class="input-field"
										  placeholder="Je client id"
										  v-model="retailerSubmit.client_id"/>
								<span class="text-danger text-sm" v-show="errors.has('clientId')">{{ errors.first('clientId') }}</span>&emsp;
							</vs-col>
							<vs-col vs-w="12">
								<vs-input label="client secret" v-validate="'required'" name="clientSecret" class="input-field"
										  placeholder="Je client secret"
										  v-model="retailerSubmit.client_secret"/>
								<span class="text-danger text-sm" v-show="errors.has('clientSecret')">{{ errors.first('clientSecret') }}</span>&emsp;
							</vs-col>
							<vs-col vs-w="12">
								<vs-button class="btn-submit" @click.native="submit" color="primary" type="filled">
									Opslaan
								</vs-button>
							</vs-col>
						</vs-row>
					</div>
				</div>
			</vx-card>

			<vx-card title="VVB labels" class="mt-5" v-if="retailer.client_id !== undefined && retailer.client_secret !== undefined">
				<div class="vx-row w-full">
					<div class="vx-col w-full mb-2">
						<vs-checkbox v-model="retailerUpdate.vvb_print_reference" @change="updateVvbPrintReference">Referentie printen op VVB labels</vs-checkbox>
					</div>
					<div class="vx-col w-full">
						Wanneer deze optie actief is zal er bij het printen van VVB labels de picklist worden opgenomen onderaan het label.
					</div>

					<div class="vx-col w-full pt-5">
						Standaard wordt de referentie 5px van links en 7px vanaf links-onder het label geplaatst. Mocht dat resulteren in een ongepaste positie, dan kan deze positie aangepast worden.
					</div>
					<div class="vx-col w-1/2 mb-2">
						<vs-input label="Afstand links" type="number" v-model="retailerUpdate.vvb_offset_left" @change="updateVvbPrintReference"></vs-input>
					</div>
					<div class="vx-col w-1/2 mb-2">
						<vs-input label="Afstand onder" type="number" v-model="retailerUpdate.vvb_offset_bottom" @change="updateVvbPrintReference"></vs-input>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>


<script>
import {mapActions, mapGetters} from 'vuex';
import Vue from 'vue';
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate';
import InlineInput from '@/components/InlineInput';

Vue.use(VeeValidate);

const dict = {
	custom: {
		name: {
			required: 'Vul hier je naam in',
		},
		clientId: {
			required: 'Vul hier je id in',
		},
		clientSecret: {
			required: 'Vul hier je secret in',
		},
	}
};
Validator.localize('en', dict);
export default {
	name: 'module-webshop-bol',
	components: {InlineInput},
	data() {
		return {
			loading: true,
			retailerInfo: null,
			popupActivo: false,
			retailerSubmit: {
				client_id: '',
				client_secret: '',
			},
			retailerUpdate: {
				name: '',
				vvb_print_reference: '',
			},
			retailerNameValidation: {
				rules: 'required',
				messages: {
					required: 'Vul je retailer naam in.',
				}
			}
		}
	},
	mounted() {
		this.openLoading();
	},
	computed: {
		...mapGetters({
			retailer: 'retailerSetting/retailer',
		})
	},
	methods: {
		...mapActions({
			Settings: 'retailerSetting/getRetailers'
		}),
		openLoading() {
			this.$vs.loading();
			this.$store.dispatch('retailerSetting/getRetailers').then(res => {
				this.$vs.loading.close();
				if (this.retailer) {
					this.retailerUpdate.name = this.retailer.name;
					this.retailerUpdate.vvb_print_reference = this.retailer.vvb_print_reference;
					this.retailerUpdate.vvb_offset_left = this.retailer.vvb_offset_left;
					this.retailerUpdate.vvb_offset_bottom = this.retailer.vvb_offset_bottom;
				}
				this.loading = false
			})
		},
		createRetailers() {
			this.$store.dispatch('retailerSetting/createRetailers', this.retailerSubmit);
		},
		submit() {
			this.$vs.dialog({
				type: 'confirm',
				color: 'warning',
				title: 'Weet je het zeker?',
				text: 'Als je verder gaat kunt je dit niet meer veranderen',
				acceptText: 'Ja',
				cancelText: 'Nee ga terug',
				accept: this.acceptAlert,
			})
		},
		acceptAlert() {
			this.$validator.validateAll().then(result => {
				if (!result) {
					this.$vs.notify({
						color: 'danger',
						title: 'Gegevens zijn niet opgeslagen',
						text: 'Vul alle velden in',
					})
				} else {
					this.createRetailers();
					this.createnotifySucces();
				}
			})
		},
		submitChangeName(name) {
			this.retailerUpdate.name = name;
			this.$store.dispatch('retailerSetting/updateRetailers', this.retailerUpdate).then(res => {
				this.createnotifySucces();
			}).catch(err => {
				this.createnotifyFailed();
			})
		},
		updateVvbPrintReference() {
			this.$store.dispatch('retailerSetting/updateRetailers', this.retailerUpdate).then(res => {
				this.createnotifySucces();
			}).catch(err => {
				this.createnotifyFailed();
			})
		},
		cancelEdit() {
			this.popupActivo = false;
			this.retailerUpdate = {
				name: this.retailer.name,
			};
		},
		createnotifySucces() {
			this.$vs.notify({
				color: 'success',
				title: 'Wijzigingen zijn opgeslagen',
				text: 'Je gegevens zijn verwerkt.',
			})
		},
		createnotifyFailed() {
			this.$vs.notify({
				color: 'danger',
				title: 'Gegevens zijn niet opgeslagen',
				text: 'Er is iets fout gegaan.',
			})
		},
		wiki() {
			window.open(this.$store.state.wiki.wiki.retailer)
		}
	}
}
</script>

<style scoped>
.vs-input {

	width: 100%;

}
</style>
